export enum UpdateViewField {
  NotApplicable = 0,
  Name = 1,
  Settings = 2,
  FilterBy = 3,
  GroupBy = 4,
  Status = 5,
}
